import { createSignal, createEffect, onMount } from 'solid-js'
import { Portal } from 'solid-js/web'
import { addToast } from '@/components/Toast'
import { res2json } from '@/utils'
import account from '@/store/account'

const [yesterdayBets, setYesterdayBets] = createSignal([])
const [dailyBets, setdailyBets] = createSignal([])

export default function Dashboard() {
  const [loading, setLoading] = createSignal(true)

  onMount(() => {
    Promise.allSettled([
      fetch(`/api/statistics/daily-bets/yesterday`).then(res2json).then(r => setYesterdayBets(r.data ?? [])),
      //fetch(`/api/statistics/daily-bets`).then(res2json).then(r => setDailyBets(r.data ?? [])),
    ]).finally(() => { setLoading(false) })
  })

  //let elDailyBets, chartDailyBets
  //onMount(() => {
  //  chartDailyBets = new Chart(elDailyBets, {
  //    type: 'line',
  //    options: { scales: { y: { beginAtZero: true } } },
  //    data: {
  //      lables: ['1', '2', '3'],
  //      datasets: [
  //        {
  //          label: '玩家投注指令数量',
  //          data: [1, 2, 3],
  //          //fill: false,
  //          borderColor: '#f00',
  //          tension: 0.1
  //        }
  //      ]
  //    }
  //  })
  //})

  //createEffect(() => {
  //  const rows = dailyBets()
  //  if (rows.length) {
  //    chartDailyBets.data.datasets.push({
  //    })
  //    chartDailyBets.update('reset')
  //  }
  //})

  return (
    <>
      <div class="flex flex-col gap-4 lg:gap-6">
        <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between">
          <div>欢迎您 {account().username}</div>
        </div>
        <div>
          {yesterdayBets().length > 0 && (
            <div class="stats stats-vertical lg:stats-horizontal shadow">
              <div class="stat">
                <div class="stat-title">昨日投注代理数量</div>
                <div class="stat-value">{yesterdayBets()[0].number_of_agents}</div>
                {yesterdayBets().length > 1 && (
                  yesterdayBets()[0].number_of_agents >= yesterdayBets()[1].number_of_agents
                  ? <div class="stat-desc">较前日增加 <span class="text-success">{yesterdayBets()[0].number_of_agents - yesterdayBets()[1].number_of_agents}</span> 位</div>
                  : <div class="stat-desc">较前日减少 <span class="text-error">{yesterdayBets()[1].number_of_agents - yesterdayBets()[0].number_of_agents}</span> 位</div>
                )}
              </div>
              <div class="stat">
                <div class="stat-title">昨日投注玩家数量</div>
                <div class="stat-value">{yesterdayBets()[0].number_of_players}</div>
                {yesterdayBets().length > 1 && (
                  yesterdayBets()[0].number_of_players >= yesterdayBets()[1].number_of_players
                  ? <div class="stat-desc">较前日增加 <span class="text-success">{yesterdayBets()[0].number_of_players - yesterdayBets()[1].number_of_players}</span> 位</div>
                  : <div class="stat-desc">较前日减少 <span class="text-error">{yesterdayBets()[1].number_of_players - yesterdayBets()[0].number_of_players}</span> 位</div>
                )}
              </div>
              <div class="stat">
                <div class="stat-title">昨日玩家投注指令数量</div>
                <div class="stat-value">{yesterdayBets()[0].number_of_player_bet_slips}</div>
                {yesterdayBets().length > 1 && (
                  yesterdayBets()[0].number_of_player_bet_slips >= yesterdayBets()[1].number_of_player_bet_slips
                  ? <div class="stat-desc">较前日增加 <span class="text-success">{yesterdayBets()[0].number_of_player_bet_slips - yesterdayBets()[1].number_of_player_bet_slips}</span> 笔</div>
                  : <div class="stat-desc">较前日减少 <span class="text-error">{yesterdayBets()[1].number_of_player_bet_slips - yesterdayBets()[0].number_of_player_bet_slips}</span> 笔</div>
                )}
              </div>
              <div class="stat">
                <div class="stat-title">昨日投注机器人数量</div>
                <div class="stat-value">{yesterdayBets()[0].number_of_robots}</div>
                {yesterdayBets().length > 1 && (
                  yesterdayBets()[0].number_of_robots >= yesterdayBets()[1].number_of_robots
                  ? <div class="stat-desc">较前日增加 <span class="text-success">{yesterdayBets()[0].number_of_robots - yesterdayBets()[1].number_of_robots}</span> 位</div>
                  : <div class="stat-desc">较前日减少 <span class="text-error">{yesterdayBets()[1].number_of_robots - yesterdayBets()[0].number_of_robots}</span> 位</div>
                )}
              </div>
              <div class="stat">
                <div class="stat-title">昨日机器人投指令数量</div>
                <div class="stat-value">{yesterdayBets()[0].number_of_robot_bet_slips}</div>
                {yesterdayBets().length > 1 && (
                  yesterdayBets()[0].number_of_robot_bet_slips >= yesterdayBets()[1].number_of_robot_bet_slips
                  ? <div class="stat-desc">较前日增加 <span class="text-success">{yesterdayBets()[0].number_of_robot_bet_slips - yesterdayBets()[1].number_of_robot_bet_slips}</span> 笔</div>
                  : <div class="stat-desc">较前日减少 <span class="text-error">{yesterdayBets()[1].number_of_robot_bet_slips - yesterdayBets()[0].number_of_robot_bet_slips}</span> 笔</div>
                )}
              </div>
            </div>
          )}
        </div>
        {/*
        <div>
          <div class="card w-96 shadow">
            <div class="card-body">
              <h2 class="card-title">每日投注统计</h2>
            </div>
            <canvas ref={elDailyBets}></canvas>
          </div>
        </div>
        */}
      </div>

      <Portal mount={document.body}>
        {loading() && (<div class="fixed left-2 right-2 bottom-0"><progress class="progress progress-success w-full"></progress></div>)}
      </Portal>
    </>
  )
}
